import React from 'react';
import { XIcon } from 'lucide-react';
import type { useProductFilters } from '../../hooks/useProductFilters';
import { capacityBuckets, priceBuckets } from '../../data/filters';
type FilterApi = ReturnType<typeof useProductFilters>;
export function ActiveFilters({
  api
}: {
  api: FilterApi;
}) {
  const {
    filters,
    setFilters,
    toggleBrand,
    clearAll,
    activeCount
  } = api;
  if (activeCount === 0) return null;
  const chips: {
    label: string;
    onRemove: () => void;
  }[] = [...filters.brands.map(b => ({
    label: b,
    onRemove: () => toggleBrand(b)
  }))];
  const price = priceBuckets.find(b => b.id === filters.price);
  if (price) chips.push({
    label: price.label,
    onRemove: () => setFilters(f => ({
      ...f,
      price: null
    }))
  });
  const cap = capacityBuckets.find(b => b.id === filters.capacity);
  if (cap) chips.push({
    label: cap.label,
    onRemove: () => setFilters(f => ({
      ...f,
      capacity: null
    }))
  });
  if (filters.inStock) chips.push({
    label: 'Op voorraad',
    onRemove: () => setFilters(f => ({
      ...f,
      inStock: false
    }))
  });
  if (filters.onSale) chips.push({
    label: 'In de aanbieding',
    onRemove: () => setFilters(f => ({
      ...f,
      onSale: false
    }))
  });
  return <div className="flex flex-wrap items-center gap-2" data-id="element-588" data-mp="zq2sr25qx181">
      {chips.map(c => <button key={c.label} type="button" onClick={c.onRemove} className="inline-flex h-8 items-center gap-1.5 rounded-full bg-ink pl-3 pr-2 text-xs font-medium text-white hover:bg-ink-soft" aria-label={`Filter ${c.label} verwijderen`} data-id="element-589" data-mp="zo9kxjjecayg">
          {c.label}
          <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-590" data-mp="gzuv2zktf2z8" />
        </button>)}
      <button type="button" onClick={clearAll} className="ml-1 text-xs font-semibold text-ink underline underline-offset-2" data-id="element-591" data-mp="gxryfwp5qblj">
        Alles wissen
      </button>
    </div>;
}